import { HOMETREE_PMT_OPTION_SETUP_EXTERNAL_ID } from 'projectSections/designPanels/StudioErrorPrompts/hometree/constants'
import { PAYMENT_OPTION_MESSAGE_TYPE_ENUM } from './types'

export const PAYMENT_TYPE_LABEL_MAP = {
  lease: 'Lease',
  loan: 'Loan',
  regular_payment: 'Regular Payment',
  cash: 'Cash',
  ppa: 'PPA',
  prepaid_lease: 'Prepaid Lease',
  prepaid_ppa: 'Prepaid PPA',
}

export const PAYMENT_FREQUENCY_MAP = {
  monthly: 'Monthly',
  bimonthly: 'Bimonthly',
  fortnightly: 'Fortnightly',
  weekly: 'Weekly',
  quarterly: 'Quarterly',
  yearly: 'Annually',
}

export const ROW_WIDTHS = ['3%', '35%', '5%', '15%', '12%', '10%', '10%', '10%']

export const MESSAGE_TYPE_PRIORITY = {
  disabled: 0,
  error: 1,
  warning: 2,
}

export const INTEGRATIONS_WITHOUT_QUICK_CALCS = ['lightreach', 'hometree', 'cloover']
export const INTEGRATION_SETUP_PAYMENT_OPTIONS = [HOMETREE_PMT_OPTION_SETUP_EXTERNAL_ID] // List all integration setup payment options here

export const MESSAGE_TYPE_ERROR_AND_DISABLED = [
  PAYMENT_OPTION_MESSAGE_TYPE_ENUM.error,
  PAYMENT_OPTION_MESSAGE_TYPE_ENUM.disabled,
]
